import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import Anchor from "../elements/Anchor";

import "swiper/css";
import "swiper/css/navigation";
import "../../styles/components/slices/google_reviews.scss";

const GoogleReviews = ({ slice }) => {
  if (!slice) return null;
  // console.log(slice.items);

  return (
    <Container fluid className="google-reviews">
      <Container className="max-container">
        <Row>
          <h2 className="title-65 text-white text-center mb-4">
            {slice.primary.title.text}
          </h2>
        </Row>
        <Row className="justify-content-center text-center text-white mb-md-5">
          <Col md={7} className="text-white">
            <PrismicRichText field={slice.primary.description.richText} />
          </Col>
        </Row>
        <Row className="justify-content-center text-center text-white mb-5">
          <Col md={7}>
            <div
              className="elfsight-app-0da622c0-c773-47d4-b7dc-36d1e2844828"
              data-elfsight-app-lazy
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <div
          className="elfsight-app-2420f2da-6492-4c1e-b08c-67d5b3223602"
          data-elfsight-app-lazy
        />
      </Container>
    </Container>
  );
};

export default GoogleReviews;
